// Issue with watermelonDB library https://github.com/Nozbe/WatermelonDB/issues/629
// @ts-nocheck
import { Model } from '@nozbe/watermelondb';
import { field, date, readonly } from '@nozbe/watermelondb/decorators';
import { setGenerator } from '@nozbe/watermelondb/utils/common/randomId';
import { v4 as uuidv4 } from 'uuid';

setGenerator(uuidv4);

export default class EventHorse extends Model {
    static table = 'event_horses';

    static associations = {
        events: { type: 'belongs_to', key: 'event_id' },
        horses: { type: 'belongs_to', key: 'horse_id' },
    };

    @field('event_id') eventId;
    @field('horse_id') horseId;
    @field('user_id') userId;
    @field('organisation_id') organisationId;
    @date('created_at') createdAt;
    @date('updated_at') updatedAt;
}

export type EventHorseSimple = {
    id: string;
    eventId: string;
    horseId: string;
    userId: string;
    organisationId: string;
    createdAt: string;
    updatedAt: string;
};
